import { render, staticRenderFns } from "./ConnectBand.vue?vue&type=template&id=cbe36cd4&"
import script from "./ConnectBand.vue?vue&type=script&lang=js&"
export * from "./ConnectBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports